// extracted by mini-css-extract-plugin
export default {"skills":"skills_skills__d4AdI","showcase":"skills_showcase__VqwXd","stack_list":"skills_stack_list__H4WAT","stack":"skills_stack__jZWpJ"};